import { render, staticRenderFns } from "./custFollowWithReportNoStrain.vue?vue&type=template&id=5d52fd1a&scoped=true&"
import script from "./custFollowWithReportNoStrain.vue?vue&type=script&lang=js&"
export * from "./custFollowWithReportNoStrain.vue?vue&type=script&lang=js&"
import style0 from "./custFollowWithReportNoStrain.vue?vue&type=style&index=0&id=5d52fd1a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d52fd1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d52fd1a')) {
      api.createRecord('5d52fd1a', component.options)
    } else {
      api.reload('5d52fd1a', component.options)
    }
    module.hot.accept("./custFollowWithReportNoStrain.vue?vue&type=template&id=5d52fd1a&scoped=true&", function () {
      api.rerender('5d52fd1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/report/custFollowWithReportNoStrain/custFollowWithReportNoStrain.vue"
export default component.exports